import React from "react"
import ContentLoader from "react-content-loader"

export default function LoadingPlaceholder() {
  return (
    <ContentLoader viewBox="0 0 380 1000">
      <rect x="15" y="15" rx="8" ry="8" width="350" height="240"/>
      <rect x="15" y="265" rx="8" ry="8" width="350" height="240"/>
      <rect x="15" y="515" rx="8" ry="8" width="350" height="240"/>
      <rect x="15" y="765" rx="8" ry="8" width="350" height="240"/>
    </ContentLoader>
  )

}
